<template>
    <the-layout>
      <router-view />
    </the-layout>
</template>

<script>
    import TheLayout from "@/views/layout/layoutView.vue";

      export default {
        name: 'App',
        components: {
            TheLayout,
        },
        created(){
          console.log("@@@@@ layout router : %o",this.$router);
        }
    }
</script>